// extracted by mini-css-extract-plugin
export var body = "_la-8";
export var button = "_la-0";
export var closeButton = "_la-5";
export var content = "_la-3";
export var empty = "_la-f";
export var grid = "_la-c";
export var header = "_la-4";
export var icon = "_la-1";
export var option = "_la-d";
export var optionSelected = "_la-e";
export var overlay = "_la-2";
export var searchIcon = "_la-a";
export var searchInput = "_la-b";
export var searchWrapper = "_la-9";
export var title = "_la-6";
export var visuallyHidden = "_la-7";